export const CHARTTYPES = {
  CAPITAL_GROWTH: 0,
  SUBURB_PEFORMANCE: 1,
  PORTFOLIO_VALUE: 2,
  PORTFOLIO_VALUE_MOBILE: 3
};
